export const normalizeString = (string) => {
  return string?.toLowerCase()?.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .replace(/([^\w]+|\s+)/g, '-')
  .replace(/\-\-+/g, '-')
  .replace(/\s/g, '')
  .replace(/(^-+|-+$)/g, '')
}

export const formatStringAndNormalizeToSearch = (value1, value2) => {
  return normalizeString(value1).indexOf(normalizeString(value2)) !== -1
}

export const sortAlphabetically = (data, key = "name") => {
  return data.sort((a, b) => (a[key] || "").toString().localeCompare((b[key] || "").toString()))
  }